module.exports = "/assets/data/323d1fb20d30b9ded687c47729ddb932-NE23.data.json";